import { PropsWithChildren } from "react";

import { SUPPORT_EMAIL } from "@/constants/common.constants";
import {
  useCurrentOrganizationContext,
  useCurrentPlatformContext,
  useCurrentUserContext,
  useDomainBrandingContext,
  useUserRolesContext,
} from "@/contexts";
import { FormattedMessage, useT } from "@/i18n";
import { IconError, TextButtonLink } from "@/ui";
import { ErrorPage, ErrorPageButton } from "@/ui/ErrorPage";

import SplashScreen from "../components/SplashScreen";

export const SplashScreenProvider = ({ children }: PropsWithChildren) => {
  const t = useT();
  const { loading: currentUserLoading, isError: isCurrentUserError } = useCurrentUserContext();
  const { isError: isOrganizationError } = useCurrentOrganizationContext();

  const { isError: isPlatformError, loading: isPlatformLoading } = useCurrentPlatformContext();
  const { isError: isUserRolesError } = useUserRolesContext();
  const { loading: isDomainBrandingLoading } = useDomainBrandingContext();

  const isError = isCurrentUserError || isOrganizationError || isPlatformError || isUserRolesError;

  return currentUserLoading || isPlatformLoading || isDomainBrandingLoading ? (
    <SplashScreen className="bg-surface-1" />
  ) : isError ? (
    <ErrorPage
      title={t("general.components.errorPage.title")}
      description={
        <FormattedMessage
          i18nKey="general.components.errorPage.description"
          components={{
            supportLink: (
              <TextButtonLink
                className="preset-body-lg! underline"
                href={`mailto:${SUPPORT_EMAIL}`}
              />
            ),
          }}
        />
      }
      icon={IconError}
      actions={
        <ErrorPageButton size="lg" className="flex-1" onPress={() => window.location.reload()}>
          {t("general.actions.refreshPage")}
        </ErrorPageButton>
      }
    />
  ) : (
    <>{children}</>
  );
};
